import { Outlet } from "react-router-dom";
import { SidebarProvider, SidebarInset } from "@/components/ui/sidebar";
import Sidebar from "./Sidebar";
import AdminAlertsBanner from "./AdminAlertsBanner";
import { SiteProvider, useSite } from "../hooks/useSite";

// Keyed by site so every page remounts and refetches when the active site changes.
function SiteOutlet() {
  const { siteId } = useSite();
  return <Outlet key={siteId || "none"} />;
}

export default function Layout() {
  // Sidebar starts collapsed unless the user has expanded it (persisted in the sidebar:state cookie).
  const defaultOpen = !document.cookie.includes("sidebar:state=true");

  return (
    <SiteProvider>
      <SidebarProvider className="h-screen" defaultOpen={defaultOpen}>
        <Sidebar />
        <SidebarInset className="flex-1 flex flex-col min-h-0 min-w-0 bg-[#F8F9FA]">
          <AdminAlertsBanner />
          <main className="flex-1 min-w-0 overflow-auto">
            <SiteOutlet />
          </main>
        </SidebarInset>
      </SidebarProvider>
    </SiteProvider>
  );
}
